export enum PackageCategory {
  Basic,
  Main,
  Boost,
}
